import { IFetchDataRequest, IFetchDataResponse } from './types';

export type RequestInterceptor = (
  request: IFetchDataRequest
) => Promise<IFetchDataResponse<unknown> | undefined>;

export type ResponseObserver = (
  request: IFetchDataRequest,
  response: IFetchDataResponse<unknown>
) => void;

const requestInterceptors: RequestInterceptor[] = [];
const responseObservers: ResponseObserver[] = [];

export const registerRequestInterceptor = (interceptor: RequestInterceptor): void => {
  requestInterceptors.push(interceptor);
};

export const registerResponseObserver = (observer: ResponseObserver): void => {
  responseObservers.push(observer);
};

export const runRequestInterceptors = (
  request: IFetchDataRequest
): Promise<IFetchDataResponse<unknown> | undefined> =>
  requestInterceptors.reduce<Promise<IFetchDataResponse<unknown> | undefined>>(
    (chain, interceptor) =>
      chain.then((prev) => prev || interceptor(request)),
    Promise.resolve(undefined)
  );

export const notifyResponseObservers = (
  request: IFetchDataRequest,
  response: IFetchDataResponse<unknown>
): void => {
  for (const observer of responseObservers) {
    try {
      observer(request, response);
    } catch {
      // observers must not break the fetch pipeline
    }
  }
};

export const resetInterceptorsForTests = (): void => {
  requestInterceptors.length = 0;
  responseObservers.length = 0;
};
